import { Routes } from '@angular/router';
import { GroupsOverviewComponent } from './components/groups-overview/groups-overview.component';
import { EnterpriseManagementComponent } from './components/enterprise-management/enterprise-management.component';
import { EnterpriseFormComponent } from './components/enterprise-form/enterprise-form.component';
import { AdminUsersTableComponent } from './components/admin-users-table/admin-users-table.component';
import { UploadCsvComponent } from './components/upload-csv/upload-csv.component';
import { SingleSignOnComponent } from './components/single-sign-on/single-sign-on.component';
import { SettingsComponent } from './components/settings/settings.component';
import { ApplicationsComponent } from './components/applications/applications.component';
import { HomeComponent } from './components/home/home.component';
import { SitesComponent } from './components/sites/sites.component';
import { EventLogsComponent } from './components/event-logs/event-logs.component';
import { AuditLogsComponent } from './components/audit-logs/audit-logs.component';
import { AuditReportsComponent } from './components/audit-reports/audit-reports.component';
import { DevToolJobComponent } from './components/dev-tool-job/dev-tool-job.component';

export const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    {
        path: 'home',
        component: HomeComponent,
        children: [
            { path: '', redirectTo: 'groups', pathMatch: 'full' },
            { path: 'groups', component: GroupsOverviewComponent },
            { path: 'sites', component: SitesComponent },
            {
                path: 'event-logs', component: EventLogsComponent,
                children: [
                    { path: '', redirectTo: 'audit-logs', pathMatch: 'full' },
                    { path: 'audit-logs', component: AuditLogsComponent },
                    { path: 'audit-reports', component: AuditReportsComponent }
                ]
            },
            { path: 'dev-tool', component: DevToolJobComponent }
        ]
    },
    {
        path: 'group-management',
        component: EnterpriseManagementComponent,
        children: [
            { path: '', redirectTo: 'create', pathMatch: 'full' },
            { path: 'create', component: EnterpriseFormComponent },
            { path: 'administrators', component: AdminUsersTableComponent }
        ]
    },
    {
        path: 'group-management/:id',
        component: EnterpriseManagementComponent,
        children: [
            { path: '', redirectTo: 'details', pathMatch: 'full' },
            { path: 'details', component: EnterpriseFormComponent },
            { path: 'administrators', component: AdminUsersTableComponent },
            { path: 'upload-csv', component: UploadCsvComponent },
            { path: 'single-sign-on', component: SingleSignOnComponent },
            { path: 'applications', component: ApplicationsComponent },
            { path: 'settings', component: SettingsComponent }
        ]
    }
];
